//
//
//
//

export default {
  name: "VocConsole",
  created() {},
  mounted() {
    if (this.$route.query.debug) {
      import("vconsole" /* webpackChunkName: "vconsole" */).then(({ default: Vconsole }) => {
        new Vconsole()
      })
    }
  }
}
